<template>
  <div>
    <div
      class="row header q-pa-lg"
      :style="`height: ${height};background-color:${backgroundColor}`"
    >
      <div class="col-12">
        <slot name="content" v-if="hasContentSlot"></slot>
        <div v-else>
          <div class="row">
            <span class="title" :style="`color: ${titleColor}`">
              {{ title }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    titleColor: {
      type: String,
    },
    backgroundColor: {
      type: String,
    },
    height: {
      type: String,
      default: "109px",
    },
  },
  computed: {
    hasContentSlot() {
      return !!this.$slots.content;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
}
</style>
